import React, { createContext, useContext, useState, useEffect } from "react";
import { UserContext } from "./user/userContext";

const ThemeContext = createContext();

export const useThemeColor = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const { state } = useContext(UserContext);
  const [theme, setTheme] = useState("");
  const [allowMessageStreaming, setAllowMessageStreaming] = useState(false);

  useEffect(() => {
    const defaultTheme = state?.user?.userProfile?.ApplicationBackgroundMode;
    const messageStreaming = state?.user?.userProfile?.AllowMessageStreaming;
    const newTheme = defaultTheme ? defaultTheme?.toLowerCase() : "light";
    setTheme(newTheme);
    setAllowMessageStreaming(messageStreaming);
  }, [state]);

  const toggleTheme = (newTheme) => setTheme(newTheme);
  const toggleMessageStreaming = (value) => setAllowMessageStreaming(value);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, allowMessageStreaming, toggleMessageStreaming }}>
      <div className={theme === "light" ? "light-theme" : "dark-theme"}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};
export const useSkillContext = () => useContext(ThemeContext);
